/* LuckyPaws: fade-and-rise on scroll. Plain JS, no libraries.
   Elements with [data-lp-reveal] animate once when they enter the viewport.
   Respects prefers-reduced-motion. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var els = document.querySelectorAll('[data-lp-reveal]');
  if (reduce || !('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('lp-revealed'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('lp-revealed');
        io.unobserve(e.target);
      }
    });
  }, { rootMargin: '-40px' });
  els.forEach(function (el) { io.observe(el); });
})();

/* Grid-stagger: [data-lp-stagger] gets .lp-in once when it scrolls into
   view; the CSS staggers the children 40ms apart. Reduced motion: the CSS
   media query already shows everything, so adding the class is harmless. */
(function () {
  var grids = document.querySelectorAll('[data-lp-stagger]');
  if (!grids.length) return;
  if (!('IntersectionObserver' in window)) {
    grids.forEach(function (g) { g.classList.add('lp-in'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('lp-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '-40px' });
  grids.forEach(function (g) { io.observe(g); });
})();
